import { Text } from '@chakra-ui/react'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import PropTypes from 'prop-types'

const mergeColumnDef = (defaults, mergeFn) => {
    return mergeFn?.(defaults) ?? defaults
}

export const getIndexColumnDef = (mergeFn) =>
    mergeColumnDef(
        {
            id: 'index',
            Header: '#',
            Cell: IndexColumn,
            width: '30px',
            className: 'td-center',
        },
        mergeFn
    )

export const getDateTimeColumnDef = (mergeFn) =>
    mergeColumnDef({ Cell: DateTimeColumn, width: '9rem' }, mergeFn)

export const IndexColumn = (props) => {
    const {
        row: { index },
        state: { pageIndex = 0, pageSize = 0 },
    } = props
    // console.log({ pageSize })
    return pageSize * pageIndex + index + 1
}

export const DateTimeColumn = ({ value }) => {
    if (value) {
        return (
            <Text as="span" color="tryt.gray-4">
                {format(parseISO(value), 'yyyy/MM/dd HH:mm')}
            </Text>
        )
    }
}
DateTimeColumn.propTypes = {
    value: PropTypes.any,
}
